// Week 33 Voice Shadowing & Karaoke Data — Atomic Sentences { text, words[], ipa[] }
export const shadowingData = {
  week: 33,
  theme: "Corridor Safety & Friction",
  sentences: [
    {
      id: 1,
      text: "Jake was walking carefully down the school corridor after science class.",
      words: ["Jake", "was", "walking", "carefully", "down", "the", "school", "corridor", "after", "science", "class."],
      ipa: ["/ʤeɪk/", "/wəz/", "/ˈwɔːkɪŋ/", "/ˈkeəfəli/", "/daʊn/", "/ðə/", "/skuːl/", "/ˈkɒrɪdɔː/", "/ˈɑːftə/", "/ˈsaɪəns/", "/klɑːs/"],
      audio_url: "/audio/week33/shadowing_1.mp3"
    },
    {
      id: 2,
      text: "His friend Tom was running very fast past the science room.",
      words: ["His", "friend", "Tom", "was", "running", "very", "fast", "past", "the", "science", "room."],
      ipa: ["/hɪz/", "/frend/", "/tɒm/", "/wəz/", "/ˈrʌnɪŋ/", "/ˈveri/", "/fɑːst/", "/pɑːst/", "/ðə/", "/ˈsaɪəns/", "/ruːm/"],
      audio_url: "/audio/week33/shadowing_2.mp3"
    },
    {
      id: 3,
      text: "Suddenly, he lost his balance on the wet floor and slipped.",
      words: ["Suddenly,", "he", "lost", "his", "balance", "on", "the", "wet", "floor", "and", "slipped."],
      ipa: ["/ˈsʌdnli/", "/hiː/", "/lɒst/", "/hɪz/", "/ˈbæləns/", "/ɒn/", "/ðə/", "/wet/", "/flɔː/", "/ənd/", "/slɪpt/"],
      audio_url: "/audio/week33/shadowing_3.mp3"
    },
    {
      id: 4,
      text: "He fell down heavily and hurt his knee.",
      words: ["He", "fell", "down", "heavily", "and", "hurt", "his", "knee."],
      ipa: ["/hiː/", "/fel/", "/daʊn/", "/ˈhevɪli/", "/ənd/", "/hɜːt/", "/hɪz/", "/niː/"],
      audio_url: "/audio/week33/shadowing_4.mp3"
    },
    {
      id: 5,
      text: "Jake stopped immediately to help his friend stay calm.",
      words: ["Jake", "stopped", "immediately", "to", "help", "his", "friend", "stay", "calm."],
      ipa: ["/ʤeɪk/", "/stɒpt/", "/ɪˈmiːdiətli/", "/tuː/", "/help/", "/hɪz/", "/frend/", "/steɪ/", "/kɑːm/"],
      audio_url: "/audio/week33/shadowing_5.mp3"
    },
    {
      id: 6,
      text: "He called the school nurse right away.",
      words: ["He", "called", "the", "school", "nurse", "right", "away."],
      ipa: ["/hiː/", "/kɔːld/", "/ðə/", "/skuːl/", "/nɜːs/", "/raɪt/", "/əˈweɪ/"],
      audio_url: "/audio/week33/shadowing_6.mp3"
    },
    {
      id: 7,
      text: "The nurse arrived quickly with a clean bandage and a cold pack to treat the cut.",
      words: ["The", "nurse", "arrived", "quickly", "with", "a", "clean", "bandage", "and", "a", "cold", "pack", "to", "treat", "the", "cut."],
      ipa: ["/ðə/", "/nɜːs/", "/əˈraɪvd/", "/ˈkwɪkli/", "/wɪð/", "/ə/", "/kliːn/", "/ˈbændɪʤ/", "/ənd/", "/ə/", "/kəʊld/", "/pæk/", "/tuː/", "/triːt/", "/ðə/", "/kʌt/"],
      audio_url: "/audio/week33/shadowing_7.mp3"
    },
    {
      id: 8,
      text: "Everyone felt relieved, and the headmaster reminded all students never to run in corridors.",
      words: ["Everyone", "felt", "relieved,", "and", "the", "headmaster", "reminded", "all", "students", "never", "to", "run", "in", "corridors."],
      ipa: ["/ˈevrɪwʌn/", "/felt/", "/rɪˈliːvd/", "/ənd/", "/ðə/", "/hedˈmɑːstə/", "/rɪˈmaɪndɪd/", "/ɔːl/", "/ˈstjuːdnts/", "/ˈnevə/", "/tuː/", "/rʌn/", "/ɪn/", "/ˈkɒrɪdɔːz/"],
      audio_url: "/audio/week33/shadowing_8.mp3"
    }
  ]
};

export default shadowingData;
